import React, {useContext} from 'react'
import {useStyles} from "./LastUpdateInfo.css";
import {NavLink} from "react-router-dom";
import {LinearProgress} from "@mui/material";
import moment from "moment";
import {useIntl} from "react-intl";
import {FirebaseAuthContext} from "../../firebase/FirebaseAuthProvider";

const LastUpdateInfo = ({metadata, stopLoadingIndication = false}) => {
    const classes = useStyles()

    // Internationalization for simple strings
    const intl = useIntl();

    // User role of the signed-in user
    const {signedInUserRole} = useContext(FirebaseAuthContext);

    if (stopLoadingIndication && !metadata) {
        return ''
    }

    if (!metadata) {
        return <LinearProgress style={{color: "white"}}/>
    }

    // IMPORTANT: Show last edit user only for admin
    return <span>
        <b>{intl.formatMessage({
            id: 'app.utils.lastUpdate.label',
            defaultMessage: 'Last Update'
        })}: </b>
        {signedInUserRole === 'admin' &&
        <NavLink className={classes.root} to={'/admin/users/' + metadata?.lastUpdateUid + '/edit'}>
            {metadata?.lastUpdateEmail}
        </NavLink>}
        <span> {moment(metadata?.lastUpdateTime).format('DD.MM.YYYY (HH:mm:ss)')}</span>
        </span>
}
export default LastUpdateInfo
